// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"bd7fcb25","455":"6ce99dfd","977":"ca9a19fa"}[chunkId] + ".chunk.js";
};